var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{staticClass:"ml-n2"},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(`mdi-alpha-${_vm.type[0]}-box-outline`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }